// @flow
export default Object.freeze({
  ADD_IMAGES: 'ADD_IMAGES',
  ADD_IMAGES_ERROR: 'ADD_IMAGES_ERROR',
  ADD_IMAGES_RESET: 'ADD_IMAGES_RESET',
  ADD_IMAGES_SUCCESS: 'ADD_IMAGES_SUCCESS',
  GET_PHOTOS: 'GET_PHOTOS',
  GET_PHOTOS_SUCCESS: 'GET_PHOTOS_SUCCESS',
  UPDATE_IMAGES: 'UPDATE_IMAGES',
  UPDATE_IMAGES_ERROR: 'UPDATE_IMAGES_ERROR',
  UPDATE_IMAGES_RESET: 'UPDATE_IMAGES_RESET',
  UPDATE_IMAGES_SUCCESS: 'UPDATE_IMAGES_SUCCESS',
  REMOVE_IMAGES: 'REMOVE_IMAGES',
  REMOVE_IMAGES_ERROR: 'REMOVE_IMAGES_ERROR',
  REMOVE_IMAGES_START: 'REMOVE_IMAGES_START',
  REMOVE_IMAGES_SUCCESS: 'REMOVE_IMAGES_SUCCESS',
  REMOVE_IMAGES_RESET: 'REMOVE_IMAGES_RESET',
  SHOW_CONFIRM_REMOVE_IMAGE: 'SHOW_CONFIRM_REMOVE_IMAGE',
  HIDE_CONFIRM_REMOVE_IMAGE: 'HIDE_CONFIRM_REMOVE_IMAGE',
  GET_COVER_PHOTO: 'GET_COVER_PHOTO',
  GET_COVER_PHOTO_ERROR: 'GET_COVER_PHOTO_ERROR',
  GET_COVER_PHOTO_START: 'GET_COVER_PHOTO_START',
  GET_COVER_PHOTO_SUCCESS: 'GET_COVER_PHOTO_SUCCESS',
  CREATE_COVER_PHOTO: 'CREATE_COVER_PHOTO',
  CREATE_COVER_PHOTO_ERROR: 'CREATE_COVER_PHOTO_ERROR',
  CREATE_COVER_PHOTO_START: 'CREATE_COVER_PHOTO_START',
  CREATE_COVER_PHOTO_SUCCESS: 'CREATE_COVER_PHOTO_SUCCESS',
  SAVE_LOGO: 'office-app/SAVE_LOGO',
  SAVE_LOGO_START: 'office-app/SAVE_LOGO_START',
  SAVE_LOGO_SUCCESS: 'office-app/SAVE_LOGO_SUCCESS',
  SAVE_LOGO_RESET: 'office-app/SAVE_LOGO_RESET',
});



// WEBPACK FOOTER //
// ./src/app/common/images/imagesActionKeys.js